import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { FacilityCodeGroup } from './FacilityCodeGroup'
import { FacilityID } from './FacilityID'
import type { SearchProperty } from '../../property/infrastructure/HTTPPropertyRepository/schemas/v3/search/legacy'

export const FacilityValidation = z.object({
  codeGroup: z.instanceof(FacilityCodeGroup, {
    message: '[Facility] codeGroup of items is required',
  }),
  id: z.instanceof(FacilityID, { message: '[Facility] id is required' }),
})

export class Facility extends Model {
  static create({ codeGroup, id }: z.infer<typeof FacilityValidation>) {
    FacilityValidation.parse({ codeGroup, id })
    return new Facility(codeGroup, id)
  }

  static fromJSON({ json }: { json: ReturnType<Facility['toJSON']> }) {
    return Facility.create({
      codeGroup: FacilityCodeGroup.create({ value: json.codeGroup }),
      id: FacilityID.create({ value: json.id }),
    })
  }

  static fromPrimitive({ codeGroup, id }: { codeGroup: string; id: string }) {
    return Facility.create({
      codeGroup: FacilityCodeGroup.create({ value: codeGroup }),
      id: FacilityID.create({ value: id }),
    })
  }

  static fromSerpApiLegacy({ id }: { id: SearchProperty['facilities'][number]['name'] }) {
    return Facility.create({
      codeGroup: FacilityCodeGroup.create({ value: '' }),
      id: FacilityID.create({ value: id }),
    })
  }

  constructor(
    private readonly _codeGroup: FacilityCodeGroup,
    private readonly _id: FacilityID
  ) {
    super()
  }

  get codeGroup() { return this._codeGroup.value } // prettier-ignore
  get id() { return this._id.value } // prettier-ignore

  toJSON() {
    return { codeGroup: this.codeGroup, id: this.id }
  }
}
